/**
 * For the majority of the code in rider app we rely on mobx-persist
 * for keeping data in sync with async storage but for some small parts
 * it is helpful to access the async storage directly to have more control
 */
export enum AsyncStorageKey {
  ClientId = 'client-id',
}
